export const formatNumberToSSN = (number) => {
    let numberArray = [];
    numberArray[0] = number.substring(0, 3);
    numberArray[1] = number.substring(3, 5);
    numberArray[2] = number.substring(5);
    return numberArray.join('-');
};

export const formatNumberToAlienNumber = (number) => {
    let numberArray = [];
    numberArray[0] = number.substring(0, 3);
    numberArray[1] = number.substring(3, 6);
    numberArray[2] = number.substring(6);
    return numberArray.join('-');
};


export const removeFormat = (number) => {
    let numberArray = number.split('-');
    return numberArray.join('');
};